import { render, staticRenderFns } from "./DesmatamentoVegaComSoja2324VegaParaguai.vue?vue&type=template&id=5fb1c2c3&scoped=true&lang=pug"
import script from "./DesmatamentoVegaComSoja2324VegaParaguai.vue?vue&type=script&lang=js"
export * from "./DesmatamentoVegaComSoja2324VegaParaguai.vue?vue&type=script&lang=js"
import style0 from "./DesmatamentoVegaComSoja2324VegaParaguai.vue?vue&type=style&index=0&id=5fb1c2c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb1c2c3",
  null
  
)

export default component.exports